import { useState } from "react";
import { Button, TextField, Container, Typography } from "@mui/material";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import style from "./PhAuth.module.css";
import { useNavigate } from "react-router-dom";
import {signInWithPhoneNumber,RecaptchaVerifier} from "firebase/auth";

import { auth } from "./FirebaseConfig";

const Example = () => {
  const [error, setError] = useState("");
  const [number, setNumber] = useState("");
  const [flag, setFlag] = useState(false);
  const [otp, setOtp] = useState("");
  const [result, setResult] = useState(null);
  const navigate = useNavigate();

  const getOtp = async (e) => {

    e.preventDefault();
    setError("");
    if (!number) return setError("Please enter a valid phone number!");

    try {
      const response = await setUpRecaptha(number);
      setResult(response);
      setFlag(true);
    } catch (err) {
      setError(err.message);
    }
  };


  const setUpRecaptha = (number) => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(auth, "recaptcha-container", {
        size: "invisible",
        callback: (response) => {
          console.log("Recaptcha resolved", response);
        },
      });
    }
    
    const recaptchaVerifier = window.recaptchaVerifier;
    return signInWithPhoneNumber(auth, number, recaptchaVerifier);
  };
  
  const verifyOtp = async (e) => {
    e.preventDefault();
    setError("");
    if (!otp) return setError("Please enter OTP!");

    try {
      await result.confirm(otp);
      navigate("/home");
    } catch (err) {
      setError(err.message);
      console.log(err);
    }
  };

  return (
    <Container maxWidth="sm">
      <Typography variant="h4" align="center" sx={{ mt: 8 }}>
        Phone Authentication
      </Typography>

      {error && (
        <Typography color="error" align="center">
          {error}
        </Typography>
      )}

      <form onSubmit={getOtp}>
        <div className={style.login}>
          <PhoneInput
            placeholder="Enter phone number"
            value={number}
            onChange={setNumber}
            defaultCountry="US"
          />
          <Button type="submit" variant="contained" color="primary" sx={{ mt: 2 }}>
            Get OTP
          </Button>
          <div id="recaptcha-container"></div>
        </div>
      </form>

      {flag && (
        <form onSubmit={verifyOtp}>
          <div className={style.login} style={{ marginTop: "2rem" }}>
            <TextField
              type="number"
              label="Enter OTP"
              variant="outlined"
              fullWidth
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            <Button type="submit" variant="contained" color="secondary" sx={{ mt: 2 }}>
              Verify OTP
            </Button>
          </div>
        </form>
      )}
    </Container>
  );
};

export default Example;
